import {BaseFlagProps} from 'platform/components';

import {ifElse, isNil, map} from 'ramda';

import {EntityTag} from '@dms/api/shared';

import {Nullish} from 'shared/web';

// doesn't contain correct color schema
export const tagsToFlags = ifElse<EntityTag[] | Nullish, Nullish, Nullish, BaseFlagProps[]>(
  isNil,
  (val) => val,
  map<EntityTag, BaseFlagProps>((e) => ({label: e.valueName, colorScheme: e.valueColor}))
);
